import './TabStyles.css';
import { getServiceTier } from '../../../utils/tierHelper';

const ServicesTab = ({ person, handleSubscribe }) => {
    return (
        <div className="about-tab">
            <section className="about-section">
                <h2 className="about-section__title">Services Offered</h2>
                <div className="about-services">
                    {person.services.map(service => {
                        const tier = getServiceTier(service.price);
                        const TierIcon = tier.icon;
                        return (
                            <div key={service.id} className="about-service about-service--card" onClick={() => handleSubscribe(service)}>
                                <div className="about-service__top">
                                    <div className="about-service__info">
                                        <h3 className="about-service__name">{service.name}</h3>
                                        <p className="about-service__desc">{service.description}</p>
                                    </div>
                                    <div className="about-service__tier" style={{ color: tier.color }}>
                                        <TierIcon style={{ fontSize: '1.5rem' }} />
                                    </div>
                                </div>
                                <div className="about-service__price-bottom">
                                    <span className="about-service__amount">R {service.price}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </section>
        </div>
    );
};

export default ServicesTab;
